import AbstractProvider from './AbstractProvider'

export default class YouTubeProvider extends AbstractProvider {

    constructor(media) {
        super(media)
    }

    init(embedId) {
        return this.initPlayer(new YT.Player(embedId))
    }

    pause() {
        if (this.player.stopVideo) {
            this.player.stopVideo()
        }
    }

    script() {
        return 'https://www.youtube.com/iframe_api'
    }

    setEmbedCode() {
        this.media.embed = `<iframe
                            width="${this.media.width}"
                            height="${this.media.height}"
                            src="${this.media.embed_url}"
                            webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0">
                            </iframe>`
    }

    ready() {
        return typeof YT !== 'undefined'
    }

}